/**
 * Asset icons live in src/assets/icons/<SYMBOL>.png (filled by `npm run icons`). Importing them through Vite gives each
 * file a content-hashed URL under /assets/, so a replaced icon is never served stale from a browser or edge cache,
 * while the immutable cache header on /assets/* still applies. Symbols without a file get undefined (monogram).
 */
const files = import.meta.glob('../assets/icons/*.png', { eager: true, query: '?url', import: 'default' }) as Record<string, string>;

export const ICONS: Readonly<Record<string, string>> = Object.fromEntries(
  Object.entries(files).map(([path, url]) => [path.slice(path.lastIndexOf('/') + 1).replace(/\.png$/, ''), url]),
);

export const iconUrl = (symbol: string): string | undefined => ICONS[symbol];
